import { TouchpointStatuses } from "types";

export const getPermittedActions = (status: TouchpointStatuses) => {
  const isDraft = status === TouchpointStatuses.DRAFT;
  const isSystemDraft = status === TouchpointStatuses.SYSTEM_DRAFT;
  const isEditable = isDraft || isSystemDraft;
  const versionIsPublished = status === TouchpointStatuses.PUBLISHED;

  return {
    isEditable,
    versionIsPublished,
  };
};
